import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { Section } from '../../components/ui/Section';
import { ActionLink } from '../../components/ui/ActionLink';
import { MockupTag } from '../../components/ui/MockupTag';
import { LocationPicker } from '../../components/ui/LocationPicker';
import { FaqList } from '../../components/ui/FaqList';
import { ContactWizard } from '../../components/contact/ContactWizard';
import { contact } from '../../data/contact';
import { destinations } from '../../data/destinations';
import { contactFaqs, contactHours } from '../../data/pageContent';
export function Contact() {
  usePageMeta('Contact ES World | Course, Camp and Visa Enquiries', 'Contact ES World about English courses, camps, professional courses, visas or accommodation. Tell us what you need and our admissions team replies within one working day.');
  return <>
      <section className="w-full bg-white px-2 pt-2 md:px-4 md:pt-4" aria-labelledby="contact-title" data-id="element-1336" data-mp="2uu3pxgpwc69e">
        <div className="rounded-[28px] bg-cream md:rounded-[40px]" data-id="element-1337" data-mp="3vpzl3l5ingom">
          <div className="mx-auto max-w-content px-5 pb-12 pt-12 md:px-8 md:pb-16 md:pt-16" data-id="element-1338" data-mp="4ivg0vsxm4iu">
            <div className="max-w-3xl" data-id="element-1339" data-mp="8kh134fmdp44">
              <h1 id="contact-title" data-id="element-1340" data-mp="8ljt5foohxlm">
                <span className="block type-h2-light text-ink" data-id="element-1341" data-mp="8ie05pcxibkm">Let&apos;s plan</span>
                <span className="block type-h2 text-brand" data-id="element-1342" data-mp="disbphdqo3ne">your next step</span>
              </h1>
              <p className="mt-5 type-body text-ink" data-id="element-1343" data-mp="3d09qay1r6uwp">
                Courses, camps, professional training, visas or accommodation — answer a few quick questions and the right team replies within one working day.
              </p>
            </div>
            <div className="mt-10 md:mt-12" data-id="element-1344" data-mp="3qpttg4z8xu6j">
              <ContactWizard data-id="element-1345" data-mp="3qrobnbj4v86x" />
            </div>
          </div>
        </div>
      </section>

      <Section id="campuses" title="Visit a campus" description="Choose a location to see the campus address. Tell us before you visit, so a team member can meet you." data-id="element-1346" data-mp="2t9xydc999hfa">
        <LocationPicker locations={destinations} data-id="element-1347" data-mp="5eitje1kt6mk" />
      </Section>

      <Section id="hours" bg="grey" title="When our team is available" description="Our admissions team answers messages during office hours. The emergency line is open at all times." mockup="Sample opening hours" data-id="element-1348" data-mp="5czflu3e77ny">
        <dl className="max-w-xl divide-y divide-line border-y border-line" data-id="element-1349" data-mp="a6anlyjxxuhg">
          {contactHours.map(row => <div key={row.day} className="flex justify-between gap-6 py-4" data-id="element-1350" data-mp="3il2gl9g2kqzw">
              <dt className="font-semibold text-ink" data-id="element-1351" data-mp="3dn0vyk2zwjmb">{row.day}</dt>
              <dd data-id="element-1352" data-mp="3dou5c74zthy0">{row.hours}</dd>
            </div>)}
        </dl>
        <MockupTag note="Times shown as 00:00" className="mt-4" data-id="element-1353" data-mp="3rnbnzqg1k492" />
      </Section>

      <Section id="faq" title="Quick answers before you write" description="These answers may help you right away." data-id="element-1354" data-mp="3mn61eoomp7xu">
        <FaqList items={contactFaqs} data-id="element-1355" data-mp="16v07fuf4ox62" />
        <div className="mt-10" data-id="element-1356" data-mp="16y4d6w88s0yu">
          <ActionLink to={contact.whatsappLink} data-id="element-1357" data-mp="11xzynbqw9gb9">Start a WhatsApp chat</ActionLink>
        </div>
      </Section>
    </>;
}